import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { WorkflowStages } from '../types';

const { WORKFLOW } = API_ENDPOINTS;

export const workflowApi = {
  getStages: () => apiClient.get<WorkflowStages>(WORKFLOW.STAGES)
};
